import { type ReactNode, useEffect, useState } from 'react';

export const AfterFirstPaint = ({ children }: { children: ReactNode }) => {
  const [hasPainted, setHasPainted] = useState(false);

  useEffect(() => {
    let hasCompleted = false;
    const reveal = () => {
      if (hasCompleted) {
        return;
      }
      hasCompleted = true;
      setHasPainted(true);
    };

    const timeoutId = window.setTimeout(reveal, 250);
    let secondFrameId: number | undefined;
    const firstFrameId = window.requestAnimationFrame(() => {
      secondFrameId = window.requestAnimationFrame(() => {
        window.clearTimeout(timeoutId);
        reveal();
      });
    });

    return () => {
      hasCompleted = true;
      window.clearTimeout(timeoutId);
      window.cancelAnimationFrame(firstFrameId);
      if (secondFrameId !== undefined) {
        window.cancelAnimationFrame(secondFrameId);
      }
    };
  }, []);

  if (!hasPainted) {
    return null;
  }

  return <>{children}</>;
};
